import React from "react";
import { Link } from "react-router-dom";

const SummerCamp = () => {
  return (
    <div>
      <p>
        We are thrilled to introduce the 2024 Anell School of Excellence Summer
        Camp Program, catering to children aged 2 to 12, both ANELL and
        non-ANELL.
      </p>
      <br />
      <p>
        Overview: Our camp promises an enriching experience with a diverse range
        of activities, including computer programming, Arts and Crafts work,
        Dance Class, Photography & Editing, Bakery, music (Keyboard, Guitar &
        Violin), Indoor games (darts, chess, Ludo, table tennis, oware and
        others), Electronic games, swimming lessons, and more.
      </p>

      <br />
      <p>
        <b>Venue: </b> Anell School of Excellence
      </p>
      <p>
        <b>Date:</b> Monday 29th July to Friday 16th August, 2024 (3 weeks)
      </p>
      <p>
        <b>Rate: </b> GHS 250.00 weekly (per child)
      </p>

      <br />
      <p>Details:</p>
      <ul>
        <li>Daily Activity Schedule</li>
        <li>
          Registration Form & Payment Details (Registration opens Monday 17th
          June, 2024)
        </li>
        <li>
          Food: Please provide snacks for your child. Water dispensers will be
          available.
        </li>
      </ul>

      <br />
      <p>
        For further inquiries, reach out to us at{" "}
        <Link to="mailto:anellschool7@gmail.com">anellschool7@gmail.com</Link>
      </p>
      <br />
      <p>We Look forward to an exciting summer filled with learning and fun!</p>

      <div className="summer-camp-schedule">
        <h2>2024 ANELL SUMMER CAMP DAILY SCHEDULE</h2>

        <div className="camp-schedule">
          <p className="camp-schedule-title">Camp Activities Schedule:</p>
          <ul className="schedule-list">
            <li>
              Engaging activities await campers to explore, experiment, and
              enjoy.
            </li>
            <li>
              Each camp day comproses five(5) activity periods, interspersed
              with snack and lunch breaks.
            </li>
          </ul>
        </div>

        <div className="camp-schedule">
          <p className="camp-schedule-title">Freedom to Choose:</p>
          <ul className="schedule-list">
            <li>
              Students have the liberty to select from a variety of activities.
            </li>
          </ul>
        </div>

        <div className="camp-schedule">
          <p className="camp-schedule-title">Daily Necessities:</p>
          <ul className="schedule-list">
            <li>
              Parents are required to provide snacks, lunch, and a bottle water
              for their child.
            </li>
            <li>All equipment for activities will be provided by us.</li>
          </ul>
        </div>

        <div className="camp-schedule">
          <p className="camp-schedule-title">Child's Duties:</p>
          <ul className="schedule-list">
            <li>
              {" "}
              It's essential for your child to bring swimwear for learners of
              ages 3 to 12 years, reading materials if available.
            </li>
          </ul>
        </div>

        {/* LOWER PRESCHOOL */}
        <div className="camp-timetable">
          <div className="timetable-header">
            <h3>Lower Pre-school</h3>
            <h5 className="timetable-info">
              Please Note: Activities Listed below are subject to change
            </h5>
          </div>
          <div className="timetable-container">
            <table>
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Monday/Tuesday/Wednesday/Thursday/Friday</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>8:00 - 8:30</td>
                  <td>Reception</td>
                </tr>
                <tr>
                  <td>8:30 - 9:00</td>
                  <td>Music and Dance (Aerobics)</td>
                </tr>
                <tr>
                  <td>9:00 - 10:00</td>
                  <td>Phonetic Sound Learning</td>
                </tr>
                <tr>
                  <td>10:00 – 10:30</td>
                  <td>Breakfast time</td>
                </tr>
                <tr>
                  <td>10:30 – 11:30</td>
                  <td>Craftwork</td>
                </tr>
                <tr>
                  <td>11:30 – 12:30</td>
                  <td>Lunch break</td>
                </tr>
                <tr>
                  <td>12:30 – 1:30</td>
                  <td>Nap time</td>
                </tr>
                <tr>
                  <td>1:30 – 2:00</td>
                  <td>Indoor/Outdoor playtime</td>
                </tr>
                <tr>
                  <td>2:00 – 2:30</td>
                  <td>Closure and Pick up (It’s time to go home)</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* UPPER PRESCHOOL */}
        <div className="camp-timetable">
          <div className="timetable-header">
            <h3>Upper Pre-school</h3>
            <h5 className="timetable-info">
              Please Note: Activities Listed below are subject to change
            </h5>
          </div>
          <div className="timetable-container">
            <table>
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Monday/Wednesday/Friday</th>
                  <th>Time</th>
                  <th>Tuesday/Thursday</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>8:00 - 8:30</td>
                  <td>Reception</td>
                  <td>8:00 - 8:30</td>
                  <td>Reception</td>
                </tr>
                <tr>
                  <td>8:30 - 9:30</td>
                  <td>Reading and library</td>
                  <td>8:30 - 9:00</td>
                  <td>Aerobics</td>
                </tr>
                <tr>
                  <td>10:30 - 11:00</td>
                  <td>Snack break</td>
                  <td>9:00 – 10:00</td>
                  <td>Reading and Library</td>
                </tr>
                <tr>
                  <td>11:00 – 12:30</td>
                  <td>Arts and craftwork</td>
                  <td>10:00 – 10:45</td>
                  <td>Snack break</td>
                </tr>
                <tr>
                  <td>12:30 – 01:00</td>
                  <td>Lunch break</td>
                  <td>10:45 – 11:45</td>
                  <td>Indoor playtime</td>
                </tr>
                <tr>
                  <td>1:00 – 1:30</td>
                  <td>Outdoor games (football, basketball, volleyball)</td>
                  <td>11:45 – 12:30</td>
                  <td>Lunch break</td>
                </tr>
                <tr>
                  <td>1:30 – 2:00</td>
                  <td>swimming</td>
                  <td>10:30 – 11:30</td>
                  <td>Outdoor playtime</td>
                </tr>
                <tr>
                  <td>2:00 – 2:15</td>
                  <td>Pack up </td>
                  <td>10:30 – 11:30</td>
                  <td>Nap time</td>
                </tr>
                <tr>
                  <td>2:15 – 2:30</td>
                  <td>Pick up time </td>
                  <td>2:00 – 2:30</td>
                  <td>Pack up and Pick up</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* GRADE SCHOOL */}
        <div className="camp-timetable">
          <div className="timetable-header">
            <h3>Grade School</h3>
            <h5 className="timetable-info">
              Please Note: Activities Listed below are subject to change
            </h5>
          </div>
          <div className="timetable-container">
            <table>
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Monday/Wednesday/Friday</th>
                  <th>Time</th>
                  <th>Tuesday/Thursday</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>8:00 - 8:30</td>
                  <td>Reception</td>
                  <td>8:00 - 8:30</td>
                  <td>Reception</td>
                </tr>
                <tr>
                  <td>8:30 - 9:15</td>
                  <td>Reading and library</td>
                  <td>8:30 - 10:00</td>
                  <td>Computer programming</td>
                </tr>
                <tr>
                  <td>9:15 - 10:45</td>
                  <td>Photography and Editing</td>
                  <td>10:00 - 10:30</td>
                  <td>Snack Break</td>
                </tr>
                <tr>
                  <td>10:45 - 11:00</td>
                  <td>Snack Break</td>
                  <td>10:30 – 11:30</td>
                  <td>Indoor games (chess, ludo, darts, cards)</td>
                </tr>
                <tr>
                  <td>11:00 – 12:30</td>
                  <td>Music Class</td>
                  <td>11:30 – 12:30</td>
                  <td>Electronic games</td>
                </tr>
                <tr>
                  <td>12:30 – 12:45</td>
                  <td>Lunch break</td>
                  <td>12:30 – 12:45</td>
                  <td>Lunch break</td>
                </tr>
                <tr>
                  <td>12:45 – 2:00</td>
                  <td>Arts and Craftwork</td>
                  <td>12:45 – 1:45</td>
                  <td>Karate</td>
                </tr>
                <tr>
                  <td>2:00 – 2:30</td>
                  <td>
                    Outdoor games (basketball, football, volleyball, tag names,
                    tennis)
                  </td>
                  <td>1:45 – 2:30</td>
                  <td>Swimming</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      
      <p>
        To register for <b>Anell Summer Camp 2024</b>, click on this <Link to="https://forms.gle/BYYGyq8NTmpGZHRj6">Link</Link>.
      </p>
    </div>
  );
};

export default SummerCamp;
